import request from "@/utils/request"

const chapterAudio = (bookId, chapterId) =>
  request.get(`/api/books/${bookId}/chapters/${chapterId}/audio`, { token: true }).then((response) => response.url)

const sample = (bookSlug) =>
  request.get("/api/books/sample_url/", {
    params: { slug: bookSlug },
    token: true
  })

const trending = ({ categorySlug, limit }) => {
  const params = { limit }
  if (categorySlug) {
    params["category_slug"] = categorySlug
  }
  return request.get("/api/books/trending", { params })
}

const similar = ({ bookId }) => {
  return request.get(`/api/books/${bookId}/similar`)
}

const latest = ({ categorySlug, limit }) => {
  const params = { limit }
  if (categorySlug) {
    params["category_slug"] = categorySlug
  }
  return request.get("/api/books/latest", { params })
}

const onboarding = (categorySlugs, locale, numberOfBooksToReturn) => {
  return request.get("/api/books/onboarding", {
    /* eslint-disable-next-line camelcase */
    params: { category_slugs: categorySlugs, number_of_books_to_return: numberOfBooksToReturn, locale },
    token: true
  })
}

export default {
  sample,
  trending,
  latest,
  similar,
  onboarding
}
